





















































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Pdf from "@/components/Pdf.vue";
import Galery from "@/components/Galery.vue";
import Footer from "@/components/Footer.vue";
import Carousel from "@/components/Carousel/Carousel.vue";
import Slide from "@/components/Carousel/Slide.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
@Component({
  components: {
    Header,
    Menu,
    Pdf,
    Galery,
    Footer,
    Carousel,
    NextPrevBtn,
    Slide,
  },
})
export default class ProExample extends Vue {
  protected galerySelected = false;
  protected carouselSelected = false;
  protected nbCarousel = 0;
  protected nbGalery = 0;
  protected nb = 0;
  protected galeryTitres: string[] = [
    "Magazine de GEII de l'IUT",
    "Critique de cinéma",
    "Le dossier de presse",
    "Analyse d'articles de presse",
  ];
  //tableaux de stockage des images des carousels
  protected carouselMagazine1: string[] = [
    "/picture_OWcom/Magazine/Magazine1.jpg",
    "/picture_OWcom/Magazine/Magazine2.jpg",
    "/picture_OWcom/Magazine/Magazine3.jpg",
    "/picture_OWcom/Magazine/Magazine4.jpg",
    "/picture_OWcom/Magazine/Magazine5.jpg",
    "/picture_OWcom/Magazine/Magazine6.jpg",
    "/picture_OWcom/Magazine/Magazine7.jpg",
    "/picture_OWcom/Magazine/Magazine8.jpg",
    "/picture_OWcom/Magazine/Magazine9.jpg",
    "/picture_OWcom/Magazine/Magazine10.jpg",
    "/picture_OWcom/Magazine/Magazine11.jpg",
    "/picture_OWcom/Magazine/Magazine12.jpg",
    "/picture_OWcom/Magazine/Magazine13.jpg",
    "/picture_OWcom/Magazine/Magazine14.jpg",
    "/picture_OWcom/Magazine/Magazine15.jpg",
    "/picture_OWcom/Magazine/Magazine16.jpg",
  ];
  protected carouselCriticCinema: string[] = [
    "/picture_OWcom/Criticism/CinemaCriticismGard.jpg",
    "/picture_OWcom/Criticism/CinemaCriticism1.png",
    "/picture_OWcom/Criticism/CinemaCriticism2.png",
  ];
  protected carouselPress1: string[] = [
    "/picture_OWcom/Press/_PressRobotic1.jpg",
    "/picture_OWcom/Press/_PressRobotic2.jpg",
    "/picture_OWcom/Press/_PressRobotic3.jpg",
    "/picture_OWcom/Press/_PressRobotic4.jpg",
    "/picture_OWcom/Press/_PressRobotic5.jpg",
    "/picture_OWcom/Press/_PressRobotic6.jpg",
    "/picture_OWcom/Press/_PressRobotic7.jpg",
    "/picture_OWcom/Press/_PressRobotic8.jpg",
    "/picture_OWcom/Press/_PressRobotic9.jpg",
    "/picture_OWcom/Press/_PressRobotic10.jpg",
    "/picture_OWcom/Press/_PressRobotic11.jpg",
    "/picture_OWcom/Press/_PressRobotic12.jpg",
  ];
  protected carouselPress2: string[] = [
    "/picture_OWcom/Press/PressRobotic1.jpg",
    "/picture_OWcom/Press/PressRobotic2.jpg",
    "/picture_OWcom/Press/PressRobotic3.jpg",
    "/picture_OWcom/Press/PressRobotic4.jpg",
    "/picture_OWcom/Press/PressRobotic5.jpg",
    "/picture_OWcom/Press/PressRobotic6.jpg",
    "/picture_OWcom/Press/PressRobotic7.jpg",
    "/picture_OWcom/Press/PressRobotic8.jpg",
    "/picture_OWcom/Press/PressRobotic9.jpg",
    "/picture_OWcom/Press/PressRobotic10.jpg",
    "/picture_OWcom/Press/PressRobotic11.jpg",
  ];
  protected carouselPress3: string[] = [
    "/picture_OWcom/Press/PressArt1.jpg",
    "/picture_OWcom/Press/PressArt2.jpg",
    "/picture_OWcom/Press/PressArt3.jpg",
    "/picture_OWcom/Press/PressArt4.jpg",
    "/picture_OWcom/Press/PressArt5.jpg",
    "/picture_OWcom/Press/PressArt6.jpg",
    "/picture_OWcom/Press/PressArt7.jpg",
    "/picture_OWcom/Press/PressArt8.jpg",
    "/picture_OWcom/Press/PressArt9.jpg",
    "/picture_OWcom/Press/PressArt10.jpg",
    "/picture_OWcom/Press/PressArt11.jpg",
    "/picture_OWcom/Press/PressArt12.jpg",

  ];

  protected carouselPressCovid2: string[] = [
    "/picture_OWcom/Press/PressCovid19Final1.jpg",
    "/picture_OWcom/Press/PressCovid19Final2.jpg",
    "/picture_OWcom/Press/PressCovid19Final3.jpg",
    "/picture_OWcom/Press/PressCovid19Final4.jpg",
    "/picture_OWcom/Press/PressCovid19Final5.jpg",
    "/picture_OWcom/Press/PressCovid19Final6.jpg",
    "/picture_OWcom/Press/PressCovid19Final7.jpg",
    "/picture_OWcom/Press/PressCovid19Final8.jpg",
    "/picture_OWcom/Press/PressCovid19Final9.jpg",
    "/picture_OWcom/Press/PressCovid19Final10.jpg",
    "/picture_OWcom/Press/PressCovid19Final11.jpg",
    "/picture_OWcom/Press/PressCovid19Final12.jpg",
    "/picture_OWcom/Press/PressCovid19Final13.jpg",
  ];

  protected carouselPressTurc2: string[] = [
    "/picture_OWcom/Press/PressTurcFinal1.jpg",
    "/picture_OWcom/Press/PressTurcFinal2.jpg",
    "/picture_OWcom/Press/PressTurcFinal3.jpg",
    "/picture_OWcom/Press/PressTurcFinal4.jpg",
    "/picture_OWcom/Press/PressTurcFinal5.jpg",
    "/picture_OWcom/Press/PressTurcFinal6.jpg",
    "/picture_OWcom/Press/PressTurcFinal7.jpg",
    "/picture_OWcom/Press/PressTurcFinal8.jpg",
    "/picture_OWcom/Press/PressTurcFinal9.jpg",
    "/picture_OWcom/Press/PressTurcFinal10.jpg",
    "/picture_OWcom/Press/PressTurcFinal11.jpg",
    "/picture_OWcom/Press/PressTurcFinal12.jpg",
  ];
  //tableau de stockage des carousels
  protected galeryPressFolder: string[][] = [
    this.carouselPress1,
    this.carouselPress2,
    this.carouselPress3,
  ];
  protected galeryPress: string[][] = [
    this.carouselPressCovid2,

    this.carouselPressTurc2,
  ];

  protected galeryMagazine: string[][] = [this.carouselMagazine1];
  protected galeryCritic: string[][] = [this.carouselCriticCinema];
  protected galery: string[][][] = [
    this.galeryMagazine,
    this.galeryCritic,
    this.galeryPressFolder,
    this.galeryPress,
  ];

  protected displayGalery(src: string[][]): void {
    this.carouselSelected = false;
    this.nbGalery = this.galery.indexOf(src);
    if (this.galerySelected == false) {
      this.galerySelected = true;
    }
  }
  protected displayCarousel(src: string[]): void {
    this.nbCarousel = this.galery[this.nbGalery].indexOf(src) + 1;
    if (this.carouselSelected == false) {
      this.carouselSelected = true;
    }
  }
  protected nxtprevProExample = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail5.png",
    NextImage: "",
    PrevLink: "/Ecrit_Pro/Orthographe",
    NextLink: "",
  };
}
